import React, {forwardRef} from "react"
import {styled} from "@mui/material/styles"
import {Grid} from "@mui/material"
import {breakpoints} from "@next/themes"
import {PropsOf} from "@emotion/react"
import {ItemsPerRow} from "models/SearchState"
import StyledProductGridItem from "./styledProductGridItem"
import StyledProductGridWrapper from "./styledProductGridWrapper"

export const StyledProductsRoot = styled(Grid)`
    z-index: 3;
    position: relative;
    flex: 1 0 80%;
    align-content: flex-start;
    min-width: 0;

    @media (min-width: ${breakpoints.values.lg}px) {
        flex: 1 0 75%;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        flex: 1 0 75%;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        flex: 1 0 80%;
    }
`

export const ProductsRoot = forwardRef<HTMLDivElement, PropsOf<typeof StyledProductsRoot>>(function ProductsRoot(
    props,
    ref,
) {
    return <StyledProductsRoot container ref={ref} {...props} />
})

export const ProductGridWrapper = forwardRef<HTMLDivElement, PropsOf<typeof StyledProductGridWrapper>>(
    function ProductGridWrapper(props, ref) {
        return <StyledProductGridWrapper container ref={ref} {...props} />
    },
)

export const StyledProductGrid = styled(Grid)`
    position: relative;
    z-index: 0;
`

export const ProductGrid = forwardRef<HTMLDivElement, PropsOf<typeof StyledProductGrid>>(function WrappedProductGrid(
    props,
    ref,
) {
    return <StyledProductGrid container {...props} ref={ref} />
})

type ProductGridItemProps = PropsOf<typeof StyledProductGridItem> & {
    columnWidthModifier?: number
    itemsPerRow: ItemsPerRow
    tileCount?: number
}

export const ProductGridItem = forwardRef<HTMLDivElement, ProductGridItemProps>(function ProductGridItem(
    {columnWidthModifier = 12, injectedAd = false, itemsPerRow, tileCount = 2, ...props},
    ref,
) {
    const tileWidth = columnWidthModifier * tileCount
    return (
        <StyledProductGridItem
            item
            xs={tileWidth / itemsPerRow.xs}
            md={tileWidth / itemsPerRow.md}
            lg={tileWidth / itemsPerRow.lg}
            xl={tileWidth / itemsPerRow.xl}
            xxl={tileWidth / itemsPerRow.xxl}
            {...props}
            ref={ref}
            injectedAd={injectedAd}
        />
    )
})

export const NoResultsContainer = styled("div")`
    padding: 1rem;
    flex: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`
